// Normalize axios failures to {status, message, isCanceled} for hooks/UI.
import axios from "axios";

export function toApiError(error) {
  if (
    axios.isCancel?.(error) ||
    error?.name === "CanceledError" ||
    error?.code === "ERR_CANCELED"
  ) {
    return { status: 0, message: "canceled", isCanceled: true };
  }
  if (error?.response) {
    const detail = error.response.data?.detail;
    return {
      status: error.response.status,
      message:
        typeof detail === "string"
          ? detail
          : `Request failed (${error.response.status})`,
      isCanceled: false,
    };
  }
  return {
    status: 0,
    message: "API unreachable — is the backend running?",
    isCanceled: false,
  };
}
